import type { LoyaltyAllowedMatrixEntityList } from "src/app/features/LoyaltyAllowedMatrix/types/LoyaltyAllowedMatrixEntityList";
import type { LoyaltyAllowedMatrixDto } from "../../types/LoyaltyAllowedMatrixDto";

export const LoyaltyAllowedMatrixDtoToEntity = ({ ...rest }: Readonly<LoyaltyAllowedMatrixDto>): LoyaltyAllowedMatrixEntityList => {
    return { ...rest };
};
